import { render, staticRenderFns } from "./RateioAcordo.vue?vue&type=template&id=2d00bd34&lang=html&"
import script from "./RateioAcordo.vue?vue&type=script&lang=js&"
export * from "./RateioAcordo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/spa/administracao/RateioAcordo.vue
// module id = 975
// module chunks = 28